import type { Item } from '@/data/experience';
import { Rich, Typography } from '@/ui';
import styles from './WorkExperience.module.css';

export const WorkExperienceEntry = ({
  item,
  active,
  ref,
}: {
  item: Item;
  active: boolean;
  ref: (el: HTMLElement | null) => void;
}) => (
  <div className={styles.entry} id={item.anchor} data-active={active} ref={ref}>
    <div className={styles.head}>
      <span className={styles.period}>{item.period}</span>
      <span className={styles.heading}>
        <Typography.Headline
          level={3}
          marginTop={0}
          marginBottom={0}
          className={styles.title}
        >
          <span className={styles.activeArrow} aria-hidden={true}>
            »
          </span>
          {item.title}
        </Typography.Headline>
        {item.sub &&
          (item.subHref ? (
            <Typography.Link className={styles.subLink} href={item.subHref}>
              {item.sub}
            </Typography.Link>
          ) : (
            <span className={styles.sub}>{item.sub}</span>
          ))}
        {item.stat && <span className={styles.stat}>{item.stat}</span>}
      </span>
    </div>
    <div className={styles.body}>
      {item.paragraphs.map((paragraph, i) => (
        <Rich key={i}>{paragraph}</Rich>
      ))}
    </div>
    {item.links.length > 0 && (
      <div className={styles.entryLinks}>
        {item.links.map((l) => (
          <Typography.Link key={l.href} href={l.href}>
            {l.label}
          </Typography.Link>
        ))}
      </div>
    )}
  </div>
);
